<template>
  <div class="my-title--com">
    <section class="title-wrap">
      <div class="main-right-user-1">
        <div class="link-content-1" v-if="!userName">
          <span class="login" @click="doLogin" style="padding:0 10px 0 0">登录</span>
          <span class="register" @click="$router.push('/h5download?type=register')" style="padding:0 0 0 10px">注册</span>
        </div>
        <div class="link-content-1" v-if="!userName">
          <span class="login" @click="doLogin" style="padding:0 10px 0 0">登录</span>
          <span class="register" @click="$router.push('/h5download?type=register')" style="padding:0 0 0 10px">注册</span>
        </div>
        <div class="link-content-1" v-else>
          <span class="login" @click="beMember" style="padding:0 0 0 10px;color: red;"><u>公示会员</u></span>
          <span class="login" style="margin: 0 10px 0 8px ;">{{userName}}</span>
          <span class="login" style="margin: 0 0 0 8px ;" @click="doLogout()">退出</span>
          <!-- <span class="login" style="margin: 0 -104px 0 8px ;" @click="$router.push('/h5EHS-ehsHome')">更多</span> -->
        </div>
      </div>
    </section>
    <accountCom :showLogin.sync="loginDialogShow" @dispatchUserName="receiveName"></accountCom>
  </div>
</template>

<script>
import accountCom from '@/components/account/index'
import api from '../../api/index'
export default {
  data () {
    return {
      activeNumber: 0,
      tmier: null,
      bannerList: [],
      loginDialogShow: false,
      userName: sessionStorage.getItem('qs_user_name')
    }
  },
  mounted () {
    api.getHotList({
      type: 'publicity'
    }).then(res => {
      if (res.code === 200) {
        this.bannerList = res.data
        console.log(123456)
        console.log(res.data[0].id)
        this.$emit('seeName', res.name)
      }
    })
  },
  methods: {
    setTimer () {
      !this.timer && (this.timer = setInterval(() => {
        this.activeNumber++
        if (this.activeNumber >= this.list.length) {
          this.activeNumber = 0
        }
      }, 4500))
    },
    handleClick (item) {
      console.log(item)
      window.open(item.jumpUrl)
    },
    doLogin () {
      this.loginDialogShow = true
    },
    receiveName (val) {
      this.userName = val
      this.$emit('dispatchUserName', val)
    },
    doLogout () {
      sessionStorage.clear()
      this.$nextTick(() => {
        window.location.reload()
      })
    },
    beMember () {
      console.log('beMember')
      this.$emit('beMember1', '')
    }
  },
  computed: {
    list () {
      return this.bannerList.slice(0, 5)
    }
  },
  components: {
    accountCom
  }
}
</script>

<style lang="scss">
.my-title--com {
  height: 136px;
  flex: 0 0 118px;
  .title-wrap {
    position: fixed;
    // top: 86.6%;
    top: -10px;
    left: 0;
    width: 100%;
    background: #f2f6fc;
    z-index: 1000;
    box-shadow: 0px 1px 4px #ccc;
    .main-right-user-1 {
      flex: 0 0 auto;
      align-self: center;
      margin-left: 300px;
      padding:0 0 0 800px;
      .link-content-1 {
        z-index: 2000;
        cursor: pointer;
        position:absolute;
        right: 7.2cm;
        top:19px;
        display: flex;
        margin: 0 0 0 0;
        // margin-top: 24px;
        a {
          padding: 8px 12px;
          cursor: pointer;
          color: #333;
          &.active {
            color: #409EFF;
          }
          &:hover {
            color: #409EFF;
          }
        }
      }
    }
    .small {
      width: 69%;
      position: absolute;
      left: 15%;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .6);
      font-size: 12px;
      color: #fff;
      padding: 4px 6px;
      cursor: pointer;
    }
    .title-main {
      margin: 0 auto;
      padding: 0 24px;
      display: flex;
      width: 1280px;
      justify-content: space-between;
      .main-left {
        flex: 1 1 1%;
        display: flex;
        align-items: center;
        line-height: 1;
        // margin-left: -230px;
        // margin-bottom: -60px;
        .right {
          margin-left: 12px;
          flex: 1;
          .name {
            color: #333;
            font-size: 18px;
          }
          .des {
            font-size: 12px;
            margin-top: 4px;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        img {
          width: 40px;
          margin: 8px 0;
        }
      }
      .main-right-user {
        flex: 0 0 auto;
        align-self: center;
        .link-content {
          span {
            margin: 0 12px;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #409EFF;
            }
          }
        }
      }
      .main-right-home {
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-self: flex-end;
        .link-content {
          display: flex;
          // margin-top: 24px;
          a {
            padding: 8px 12px;
            cursor: pointer;
            color: #333;
            &.active {
              color: #409EFF;
            }
            &:hover {
              color: #409EFF;
            }
          }
        }
      }
    }
    .title-link {
      padding: 0 24px;
      padding-bottom: 8px;
      width: 1280px;
      margin: 0 auto;
      font-size: 12px;
      .link-title {
        color: #83889a;
      }
      a {
        margin-right: 8px;
        color: #409EFF;
      }
    }
  }
  .active {
    color: #409EFF;
    background: #fff;
    border-radius: 4px 4px 0 0;
  }
}
</style>
